import shared from './shared'
import store from '../store'
import { ResultUtils } from '../utils/resultUtils'
import { ResultType } from '../utils/ResultType'

export default {
    shared,
    async getResultsForUid (uid) {
        try {
            if (uid) {
                const getResultsForUid = this.shared.functions().httpsCallable('getResultsForUid')
                let results = await getResultsForUid(uid)
                return results.data
            }
        } catch (error) {
            console.error(error)
        }
        return []
    },

    async getAllMonthsForYear (year = null) {
        if (year === null) {
            year = new Date().getFullYear()
        }
        try {
            const getQuizzesByLeauge = this.shared.functions().httpsCallable('getAllMonthsForYear')
            let monthIndexes = await getQuizzesByLeauge(year)
            return monthIndexes.data
        } catch (error) {
            console.error(error)
        }
        return []
    },

    async getQuizzesByLeauge (ligaId = 4, withQuestions = false, inMonth = null) {
        if (inMonth === null) {
            inMonth = new Date().getMonth()
        }
        const request = {
            ligaId,
            withQuestions,
            inMonth
        }
        try {
            ResultUtils.validateGetQuizzesByLeaugeRequest(request)
            const getQuizzesByLeauge = this.shared.functions().httpsCallable('getQuizzesByLeauge')
            let quizzes = await getQuizzesByLeauge(request)
            return quizzes.data
        } catch (error) {
            console.error(error)
        }
        return []
    },

    async getTotalPointsByLeague (ligaId = 4, limit = 10) {
        const request = {
            ligaId,
            limit
        }
        try {
            ResultUtils.validateGetTotalPointsByLeagueRequest(request)
            const getTotalPointsByLeague = this.shared.functions().httpsCallable('getTotalPointsByLeague')
            let totalPoints = await getTotalPointsByLeague(request)
            return totalPoints.data
        } catch (error) {
            console.error(error)
        }
    },

    async getResultsForQuiz (ligaId = 4, quizId = null, limit = 10) {
        if (quizId === null) {
            throw new Error('Needs a quizId')
        }
        const request = {
            ligaId,
            quizId,
            limit
        }
        try {
            ResultUtils.validateGetResultsForQuizRequest(request)
            const getResultsForQuiz = this.shared.functions().httpsCallable('getResultsForQuiz')
            let results = await getResultsForQuiz(request)
            return results.data
        } catch (error) {
            console.error(error)
            throw new Error('Error in getResultsForQuiz')
        }
    },

    async getResultsForGroups (ligaId = 4, quizId = null, limit = 10) {
        if (quizId === null) {
            throw new Error('Needs a quizId')
        }
        const request = {
            ligaId,
            quizId,
            limit
        }
        try {
            const getResultsForGroups = this.shared.functions().httpsCallable('getResultsForGroups')
            let results = await getResultsForGroups(request)
            return results.data
        } catch (error) {
            console.error(error)
            throw new Error('Error in getResultsForGroups')
        }
    },

    async getUserResultFor (resultType, queryValue, uid) {
        try {
            if (!uid) {
                uid = store.state.user.uid
            }
            let liga = (store.state && store.state.metadata && store.state.metadata.userData && store.state.metadata.userData.liga) || 0
            return new Promise(async (resolve, reject) => {
                try {
                    let refString = `/points/${liga}/total/${uid}`
                    switch (resultType) {
                    case ResultType.Round:
                        refString = `/points/${liga}/quizes/${queryValue}/${uid}`
                        break
                    case ResultType.Month:
                        refString = `/points/${liga}/months/${queryValue}/${uid}`
                        break
                    case ResultType.Total:
                        refString = `/points/${liga}/total/${uid}`
                        break
                    }
                    this.shared.db().ref(refString).on('value', async (dataSnapshop) => {
                        let val = dataSnapshop.val()
                        if (val) {
                            switch (resultType) {
                            case ResultType.Round:
                                store.state.points.prevRound.loaded = true
                                store.state.points.prevRound.points = val.points
                                store.state.points.prevRound.position = val.position
                                break
                            case ResultType.Month:
                                store.state.points.month.loaded = true
                                store.state.points.month.points = val.points
                                store.state.points.month.position = val.position
                                break
                            case ResultType.Total:
                                store.state.points.total.loaded = true
                                store.state.points.total.points = val.points
                                store.state.points.total.position = val.position
                                break
                            }
                            resolve()
                        } else {
                            switch (resultType) {
                            case ResultType.Round:
                                store.state.points.prevRound.loaded = true
                                break
                            case ResultType.Month:
                                store.state.points.month.loaded = true
                                break
                            case ResultType.Total:
                                store.state.points.total.loaded = true
                                break
                            }
                            reject(new Error('Nema rezultata'))
                        }
                    })
                } catch (error) {
                    reject(new Error('something failes while getting round result'))
                }
            })
        } catch (error) {
            return false
        }
    }
}
